module.exports = __webpack_public_path__ + "sounds/0-100-sprite-97cdf3b0f6a95caf5227e9eaf907f7e8.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/sound/0-100/0-100-sprite.m4a
// module id = 13
// module chunks = 0